
import './input-toggle-group.css'
import ToggleInputRadio from './input-toggle-radio.tsx';
import ToggleInput from "./input-toggle.tsx";

export default function ToggleInputGroup<T>(props: {
	label: string,
  arialabel?: string,
  value: T | undefined,
  radio?: boolean,
	options: Array<{label: string, value: T, image: string}>,
  onChange: (key: T, value: boolean) => void,
}){
  return  <fieldset aria-label={props.arialabel} className='toggle-input-group'>
            <legend>{props.label}</legend>
            {props.options.map((option)=>{
              if (props.radio){
                return  <ToggleInputRadio 
                  key={option.label} 
                  label={option.label} 
                  image={option.image}
                  value={option.value == props.value} 
                  onChange={(checked:boolean)=>{
                      props.onChange(option.value, checked)
                  }}/> 
              }else{
                return  <ToggleInput 
                  key={option.label} 
                  label={option.label} 
                  image={option.image}
                  value={option.value == props.value} 
                  onChange={(checked:boolean)=>{
                      props.onChange(option.value, checked)
                  }}/> 
              }}
            )}
          </fieldset>
}
